document.addEventListener("DOMContentLoaded", function () {
  // const isSolutionsPage = window.location.pathname.includes("/solutions");
  // const isProductDetailPage = window.location.pathname.includes("/pages/discover/");
  // const pageTitle = document.querySelector(".page-title");

  const navbar = document.querySelector("header .navbar");
  const secondNavbar = document.querySelector(".second-navbar");

  const hamburger = document.querySelector(".navbar .hamburger");
  const menuCloseButton = document.querySelector(".menu-close");

  const slideMenu = document.querySelector(".slide-menu");

  const secondFlyout = document.querySelector(".flyout-menu.flyout-desktop");
  const secondFlyoutChildGroups = document.querySelectorAll(
    ".flyout-menu.flyout-desktop .child-group",
  );
  const secondFlyoutChildLinks = document.querySelectorAll(".child-group li a");

  const thirdFlyout = document.querySelector(".flyout-menu.flyout-third");

  const flyoutMobile = document.querySelector(".flyout-menu.flyout-mobile");
  const mobileLeftArrow = document.querySelector(".mobile-left-arrow");
  const mobileChildGroups = document.querySelectorAll(
    ".flyout-menu.flyout-mobile .child-group",
  );

  const languageDropdownBtnDesktop = document.querySelector(
    ".language-dropdown-desktop button",
  );
  const translationDropdownDesktop = document.querySelector(
    ".translation-dropdown-desktop",
  );

  const languageBtnMobile = document.querySelector(".language-btn");
  const translationDropdownMobile = document.querySelector(
    ".translation-dropdown-mobile",
  );

  const countryDropdownDesktop = document.querySelector(
    ".country-dropdown-desktop",
  );

  const regionButtons = document.querySelectorAll(".region-btn");
  const regionDropdowns = document.querySelectorAll(
    ".country-dropdown-desktop, .custom-region-dropdown .slide-menu-country-dropdown",
  );

  const footerSelect = document.querySelector(".thb-region-select");

  const disableScroll = () => (document.body.style.overflow = "hidden");
  const enableScroll = () => (document.body.style.overflow = "");
  const isMobile = () => window.matchMedia("(max-width: 959px)").matches;

  const uiState = {
    desktopOpen: false,
    mobileOpen: false,
    activeIndex: null,
    thirdActive: null,
  };

  let secondFlyoutOpenTimeout  = null;
  let thirdFlyoutOpenTimeout  = null;

  let flyoutsCloseTimeout = null;
  let isClosingMenu = false;
  let isHardClosing = false;
  let thirdFlyoutSuppressed = false;
  let thirdFlyoutSuppressTimeout = null;
  let thirdFlyoutLastScrollTop = 0;

  function resetDesktop() {
    document.querySelectorAll(".primary-drawer .parent-link").forEach((l) => l.classList.remove("flyout-open"));
    secondFlyout?.classList.remove("show");
    secondFlyoutChildGroups.forEach((g) => (g.style.display = "none"));

    uiState.desktopOpen = false;
    uiState.activeIndex = null;

    closeThirdFlyoutImmediate();
  }

  function resetMobile() {
    flyoutMobile?.classList.remove("show");
    mobileChildGroups.forEach((g) => (g.style.display = "none"));

    uiState.mobileOpen = false;
  }

  hamburger?.addEventListener("click", () => {
    if (hamburger.classList.contains("active")) {
      closeMenu();
    } else {
      hamburger.classList.add("active");
      slideMenu?.classList.add("active");
      document.body.classList.add("menu-active");
      disableScroll();
    }
  });

  menuCloseButton?.addEventListener("click", closeMenu);

  // Outside click to close menus
  document.addEventListener("click", (e) => {
    const target = e.target;

    const isInsideMenu =
      target.closest(".slide-menu") ||
      target.closest(".flyout-mobile") ||
      target.closest(".flyout-desktop") ||
      target.closest(".flyout-third") ||
      target.closest(".parent-link") ||
      target.closest(".hamburger");

    const isInsideDropdown =
      translationDropdownMobile?.contains(target) ||
      translationDropdownDesktop?.contains(target);

    const isTrigger =
      languageBtnMobile?.contains(target) ||
      languageDropdownBtnDesktop?.contains(target);

    if (!isInsideMenu && !isInsideDropdown && !isTrigger) {
      closeAllWithSequence();
    }

    if (!isInsideMenu && !isInsideDropdown && !isTrigger) {
      closeMobileTranslation();
    }
    if (!isInsideDropdown && !isTrigger) {
      translationDropdownDesktop?.classList.remove("show");
    }
  });

  document.querySelectorAll(".primary-drawer li").forEach((li) => {
    const link = li.querySelector(".parent-link");
    if (!link) return;

    const index = link.getAttribute("data-index");

    const activeMobileGroup = document.querySelector(
      `.flyout-menu.flyout-mobile .child-group[data-index="${index}"]`,
    );

    const activeDesktopGroup = document.querySelector(
      `.flyout-menu.flyout-desktop .child-group[data-index="${index}"]`,
    );

    // Desktop: hover to show flyout
    link.addEventListener("mouseenter", () => {
      if (isMobile()) return;
      if (isHardClosing) return;

      cancelFlyoutClose();

      const index = link.getAttribute("data-index");

      const targetGroup = document.querySelector(
        `.flyout-menu.flyout-desktop .child-group[data-index="${index}"]`,
      );

      const hasGroup = targetGroup && targetGroup.children.length;

      document.querySelectorAll(".primary-drawer .parent-link").forEach((l) => l.classList.remove("flyout-open"));
      if (hasGroup) link.classList.add("flyout-open");

      if (!hasGroup) {
        clearTimeout(secondFlyoutOpenTimeout );

        secondFlyoutChildGroups.forEach((g) => (g.style.display = "none"));
        secondFlyout?.classList.remove("show");

        uiState.desktopOpen = false;
        uiState.activeIndex = null;

        suppressThirdFlyout();
        closeThirdFlyoutImmediate();
        return;
      }

      const isSame = uiState.activeIndex === index;

      if (isSame) {
        suppressThirdFlyout();
        closeThirdFlyoutImmediate();
        return;
      }

      suppressThirdFlyout();
      closeThirdFlyoutImmediate();

      uiState.activeIndex = index;
      uiState.desktopOpen = true;

      clearTimeout(secondFlyoutOpenTimeout);

      secondFlyoutChildGroups.forEach((g) => (g.style.display = "none"));
      secondFlyout.classList.remove("show");

      secondFlyoutOpenTimeout  = setTimeout(() => {
        targetGroup.style.display = "block";
        secondFlyout.classList.add("show");
        secondFlyout.style.pointerEvents = "none";
        setTimeout(() => { secondFlyout.style.pointerEvents = ""; }, 600);
      }, 150);
    });

    // Mobile: click to slide-in flyout
    li.addEventListener("click", (e) => {
      if (!isMobile()) return;
      if (!activeMobileGroup || !activeMobileGroup.children.length) return;

      e.preventDefault();

      mobileChildGroups.forEach((g) => (g.style.display = "none"));

      activeMobileGroup.style.display = "block";
      flyoutMobile?.classList.add("show");

      uiState.mobileOpen = true;
    });

    // Prevent navigation if desktop group exists
    link.addEventListener("click", (e) => {
      if (!isMobile() && activeDesktopGroup?.children.length) {
        e.preventDefault();
      }
    });
  });

  function suppressThirdFlyout() {
    thirdFlyoutSuppressed = true;
    clearTimeout(thirdFlyoutSuppressTimeout);
    thirdFlyoutSuppressTimeout = setTimeout(() => { thirdFlyoutSuppressed = false; }, 500);
  }

  function closeThirdFlyoutImmediate() {
    if (!thirdFlyout) return;

    clearTimeout(thirdFlyoutOpenTimeout);
    thirdFlyoutOpenTimeout = null;

    secondFlyoutChildLinks.forEach((l) => (l.closest(".custom-button") || l).classList.remove("flyout-open"));
    thirdFlyout.classList.remove("show");

    thirdFlyout
      .querySelectorAll(".third-flyout-content")
      .forEach((el) => (el.style.display = "none"));

    uiState.thirdActive = null;
  }

  secondFlyoutChildLinks.forEach((link) => {
    link.addEventListener("mouseenter", () => {
      if (isMobile()) return;
      if (isHardClosing) return;
      if (!secondFlyout?.classList.contains("show")) return;
      if (thirdFlyoutSuppressed) return;

      const collectionHandle = link
        .getAttribute("href")
        ?.split("/collections/")[1];

      if (!collectionHandle) return;

      const nextContent = thirdFlyout.querySelector(
        `[data-collection="${collectionHandle}"]`,
      );

      if (!nextContent) return;

      secondFlyoutChildLinks.forEach((l) => (l.closest(".custom-button") || l).classList.remove("flyout-open"));
      (link.closest(".custom-button") || link).classList.add("flyout-open");

      showThirdFlyout(nextContent);
    });
  });

  function showThirdFlyout(nextContent) {
    if (!thirdFlyout || !nextContent) return;
    if (isClosingMenu) return;

    const currentContent = nextContent;

    if (uiState.thirdActive === currentContent) return;

    clearTimeout(thirdFlyoutOpenTimeout );

    thirdFlyout.classList.remove("show");

    thirdFlyoutOpenTimeout  = setTimeout(() => {
      if (uiState.thirdActive === currentContent) return;

      thirdFlyout
        .querySelectorAll(".third-flyout-content")
        .forEach((el) => (el.style.display = "none"));

      currentContent.style.display = "flex";

      thirdFlyout.classList.add("show");
      thirdFlyout.classList.remove("is-scrolled");
      thirdFlyout.scrollTop = 0;
      thirdFlyoutLastScrollTop = 0;

      uiState.thirdActive = currentContent;

      setTimeout(() => {
        const scrollIndicator = currentContent.querySelector(".scroll-down");
        if (!scrollIndicator) return;
        thirdFlyout.scrollTop = 1;
        const isScrollable = thirdFlyout.scrollTop > 0;
        thirdFlyout.scrollTop = 0;
        scrollIndicator.style.display = isScrollable ? "block" : "none";
      }, 50);
    }, 150);
  }

  function closeFlyoutsWithDelay() {
    clearTimeout(flyoutsCloseTimeout);

    flyoutsCloseTimeout = setTimeout(() => {
      isClosingMenu = true;

      thirdFlyout?.classList.remove("show");
      secondFlyoutChildLinks.forEach((l) => (l.closest(".custom-button") || l).classList.remove("flyout-open"));

      thirdFlyout
        ?.querySelectorAll(".third-flyout-content")
        .forEach((el) => (el.style.display = "none"));

      uiState.thirdActive = null;

      setTimeout(() => {
        secondFlyout?.classList.remove("show");
        document.querySelectorAll(".primary-drawer .parent-link").forEach((l) => l.classList.remove("flyout-open"));

        secondFlyoutChildGroups.forEach((g) => {
          g.style.display = "none";
        });

        uiState.desktopOpen = false;
        uiState.activeIndex = null;

        isClosingMenu = false;
      }, 200);
    }, 250);
  }

  function cancelFlyoutClose() {
    clearTimeout(flyoutsCloseTimeout);
    isClosingMenu = false;
  }

  thirdFlyout?.addEventListener("scroll", () => {
    const currentScrollTop = thirdFlyout.scrollTop;
    const lastScrollTop = thirdFlyoutLastScrollTop;
    thirdFlyoutLastScrollTop = currentScrollTop;

    if (currentScrollTop === 0) {
      thirdFlyout.classList.remove("is-scrolled");
    } else if (currentScrollTop > lastScrollTop) {
      thirdFlyout.classList.add("is-scrolled");
    } else if (currentScrollTop < lastScrollTop) {
      thirdFlyout.classList.remove("is-scrolled");
    }

    const scrollIndicator = uiState.thirdActive?.querySelector(".scroll-down");
    if (scrollIndicator) {
      scrollIndicator.style.display = currentScrollTop > 40 ? "none" : "block";
    }
  });

  slideMenu?.addEventListener("mouseenter", suppressThirdFlyout);

  secondFlyout?.addEventListener("mouseleave", closeFlyoutsWithDelay);
  thirdFlyout?.addEventListener("mouseleave", closeFlyoutsWithDelay);

  secondFlyout?.addEventListener("mouseenter", cancelFlyoutClose);
  thirdFlyout?.addEventListener("mouseenter", cancelFlyoutClose);

  function closeMenu() {
    resetDesktop();
    resetMobile();

    hamburger?.classList.remove("active");
    slideMenu?.classList.remove("active");

    document.body.classList.remove("menu-active");

    enableScroll();
  }

  function closeAllWithSequence() {
    if (isClosingMenu) return;

    isClosingMenu = true;
    isHardClosing = true;
    setTimeout(() => { isHardClosing = false; }, 850);

    thirdFlyout?.classList.remove("show");
    secondFlyoutChildLinks.forEach((l) => (l.closest(".custom-button") || l).classList.remove("flyout-open"));

    thirdFlyout
      ?.querySelectorAll(".third-flyout-content")
      .forEach((el) => (el.style.display = "none"));

    uiState.thirdActive = null;

    setTimeout(() => {
      secondFlyout?.classList.remove("show");
      document.querySelectorAll(".primary-drawer .parent-link").forEach((l) => l.classList.remove("flyout-open"));

      secondFlyoutChildGroups.forEach((g) => {
        g.style.display = "none";
      });

      uiState.desktopOpen = false;
      uiState.activeIndex = null;

      setTimeout(() => {
        resetMobile();

        hamburger?.classList.remove("active");
        slideMenu?.classList.remove("active");

        document.body.classList.remove("menu-active");
        enableScroll();

        isClosingMenu = false;
      }, 200);
    }, 200);
  }

  document.querySelectorAll(".parent-link").forEach((link) => {
    link.addEventListener("mouseenter", cancelFlyoutClose);
  });

  // Mobile flyout
  const primaryDrawer = document.querySelector(".primary-drawer");

  function closeMobileFlyout() {
    flyoutMobile?.classList.remove("show");
    mobileChildGroups.forEach((g) => (g.style.display = "none"));

    if (!slideMenu.classList.contains("active")) {
      document.body.classList.remove("menu-active");
    }
  }

  // Mobile: left arrow closes flyout
  mobileLeftArrow?.addEventListener("click", closeMobileFlyout);

  primaryDrawer?.addEventListener("click", (e) => {
    if (!e.target.closest(".parent-link")) {
      closeMobileFlyout();
    }
  });

  // Page title update
  // if (pageTitle) {
  //   const titleSpan = pageTitle.querySelector("span");
  //   if (isProductDetailPage) titleSpan.textContent = "Products";
  //   else if (isSolutionsPage) titleSpan.textContent = "Solutions";
  // }

  function closeMobileTranslation() {
    translationDropdownMobile?.classList.remove("show");
    if (primaryDrawer) primaryDrawer.style.marginTop = "";
  }

  // Language dropdowns
  document.addEventListener("click", function (e) {
    const btn = e.target.closest(".language-dropdown-mobile");
    if (!btn) return;
    e.stopPropagation();

    if (translationDropdownMobile?.classList.contains("show")) {
      closeMobileTranslation();
    } else {
      translationDropdownMobile?.classList.add("show");
      if (primaryDrawer && translationDropdownMobile) {
        primaryDrawer.style.marginTop = translationDropdownMobile.scrollHeight + "px";
      }
    }
  });

  languageDropdownBtnDesktop?.addEventListener("click", (e) => {
    e.preventDefault();
    const opening = !translationDropdownDesktop?.classList.contains("show");
    if (opening) alignDesktopDropdowns();
    translationDropdownDesktop?.classList.toggle("show");
  });

  // Sticky navbar
  if (!navbar) return;

  let lastScrollY = window.scrollY;
  let scrollTimeout;
  let isUserScrolling = false;
  const SCROLL_THRESHOLD = 30;

  function showNavbar(reason = "") {
    navbar.classList.remove("hide-navbar");
    secondNavbar?.classList.remove("hide-second-navbar");

    if (window.scrollY > 0) {
      navbar.classList.add("sticky");
    } else {
      navbar.classList.remove("sticky");
    }
  }

  function hideNavbar(reason = "") {
    navbar.classList.add("hide-navbar");
    secondNavbar?.classList.add("hide-second-navbar");

    if (window.scrollY > 0) {
      navbar.classList.add("sticky");
    } else {
      navbar.classList.remove("sticky");
    }
  }

  window.addEventListener("wheel", () => (isUserScrolling = true), {
    passive: true,
  });
  window.addEventListener("touchmove", () => (isUserScrolling = true), {
    passive: true,
  });

  window.addEventListener("keydown", (e) => {
    const keysThatScroll = [
      "Home",
      "End",
      "PageUp",
      "PageDown",
      "ArrowUp",
      "ArrowDown",
      " ",
    ];
    if (keysThatScroll.includes(e.key)) {
      isUserScrolling = true;

      setTimeout(() => handleScroll(), 50);
    }
  });

  function handleScroll() {
    const currentScrollY = window.scrollY;
    const delta = currentScrollY - lastScrollY;

    if (currentScrollY <= 0) {
      showNavbar("at top");
      lastScrollY = currentScrollY;
      return;
    }

    if (!isUserScrolling) return;

    if (Math.abs(delta) > SCROLL_THRESHOLD) {
      if (delta > 0) {
        hideNavbar("scrolling down");
      } else {
        showNavbar("scrolling up");
      }
      lastScrollY = currentScrollY;
    }

    clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(() => {
      showNavbar("scroll stopped");
      isUserScrolling = false;
    }, 300);
  }

  window.addEventListener("scroll", handleScroll, { passive: true });

  showNavbar();

  // Resize handler
  window.addEventListener("resize", () => {
    if (isMobile()) {
      secondFlyout?.classList.remove("show");
      secondFlyoutChildGroups.forEach((g) => (g.style.display = "none"));
      translationDropdownDesktop?.classList.remove("show");
      countryDropdownDesktop?.classList.remove("show");
      closeThirdFlyoutImmediate();
    } else {
      flyoutMobile?.classList.remove("show");
      mobileChildGroups.forEach((g) => (g.style.display = "none"));
      closeMobileTranslation();
      alignDesktopDropdowns();
    }
  });

  if (!regionButtons.length && !regionDropdowns.length) return;

  let selectedRegion =
    regionButtons[0]?.querySelector("span.text")?.textContent || "US";

  function updateAllRegions(regionCode, regionName) {
    regionButtons.forEach((btn) => {
      const textSpan = btn.querySelector("span.text");
      if (textSpan) {
        textSpan.textContent = regionName;
      } else {
        btn.innerHTML = `<span class="text">${regionName}</span>`;
      }
      btn.title = regionName;
    });

    regionDropdowns.forEach((dropdown) => {
      dropdown.querySelectorAll("[data-region]").forEach((btn) => {
        btn.classList.toggle("active", btn.dataset.region === regionCode);
      });
    });
  }

  const initialBtn = document.querySelector(
    `[data-region="${selectedRegion}"]`,
  );

  if (initialBtn) {
    updateAllRegions(selectedRegion, initialBtn.dataset.regionName);
  }

  function redirectWithSwitchingParam(target) {
    if (!target) return;

    let targetUrl = "";
    if (target.tagName === "OPTION" || target.tagName === "SELECT") {
      targetUrl = target.value || target.options[target.selectedIndex]?.value;
    } else {
      targetUrl = target.getAttribute("href") || target.dataset.url;
    }

    if (!targetUrl) return;

    fetch("/cart.js")
      .then((res) => res.json())
      .then((cart) => {
        const attrs = cart.attributes || {};
        const url = new URL(targetUrl, window.location.origin);

        url.searchParams.set("switching_country", "true");

        if (attrs.lead_source === "Affiliate Program") {
          url.searchParams.set("lead_source", attrs.lead_source);
          if (attrs.affid && attrs.oid) {
            url.searchParams.set("affid", attrs.affid);
            url.searchParams.set("oid", attrs.oid);
          } else if (attrs._ef_transaction_id) {
            url.searchParams.set(
              "_ef_transaction_id",
              attrs._ef_transaction_id,
            );
          }
        } else if (attrs.lead_source === "Replicated Site") {
          url.searchParams.set("lead_source", attrs.lead_source);
          if (attrs._rsu) url.searchParams.set("rsu", attrs._rsu);
        }

        window.location.href = url.toString();
      })
      .catch(() => {
        window.location.href = targetUrl;
      });
  }

  document.querySelectorAll(".slide-menu .region-dropdown").forEach((container) => {
    container.addEventListener("click", (e) => {
      if (e.target.closest(".region-btn")) return;
      e.stopPropagation();

      translationDropdownDesktop?.classList.remove("show");
      closeMobileTranslation();

      const dropdown = container.querySelector(".slide-menu-country-dropdown");
      if (!dropdown) return;

      const isOpen = dropdown.classList.contains("show");
      regionDropdowns.forEach((d) => { if (d !== dropdown) d.classList.remove("show"); });

      if (isOpen) {
        dropdown.classList.remove("show");
      } else {
        dropdown.classList.add("show");
      }
    });
  });

  regionButtons.forEach((btn) => {
    btn.addEventListener("click", (e) => {
      e.stopPropagation();

      translationDropdownDesktop?.classList.remove("show");
      closeMobileTranslation();

      let dropdown = btn
        .closest(".custom-region-dropdown")
        ?.querySelector(
          ".country-dropdown-desktop, .slide-menu-country-dropdown",
        );

      if (!dropdown) {
        dropdown = document.querySelector(
          ".country-dropdown-desktop, .slide-menu-country-dropdown",
        );
      }

      const isOpen = dropdown?.classList.contains("show");

      regionDropdowns.forEach((d) => {
        if (d !== dropdown) d.classList.remove("show");
      });

      if (isOpen) {
        dropdown?.classList.remove("show");
      } else {
        alignDesktopDropdowns();
        dropdown?.classList.add("show");
      }
    });
  });

  document.addEventListener(
    "click",
    function (e) {
      const activeRegionLink = e.target.closest("[data-region].active");
      if (!activeRegionLink) return;

      e.preventDefault();
      e.stopImmediatePropagation();
    },
    true,
  );

  regionDropdowns.forEach((dropdown) => {
    dropdown.querySelectorAll("[data-region]").forEach((btn) => {
      btn.addEventListener("click", (e) => {
        if (btn.classList.contains("active")) return;

        e.preventDefault();
        e.stopPropagation();

        const regionCode = btn.dataset.region;
        const regionName = btn.dataset.regionName;

        selectedRegion = regionCode;
        updateAllRegions(regionCode, regionName);

        syncFooterSelect(regionName);

        regionDropdowns.forEach((d) => d.classList.remove("show"));
        redirectWithSwitchingParam(btn);
      });
    });
  });

  document.addEventListener("click", (e) => {
    const clickedInside = e.target.closest(".custom-region-dropdown");
    if (!clickedInside) {
      regionDropdowns.forEach((d) => d.classList.remove("show"));
    }
  });

  if (footerSelect) {
    function syncFooterSelect(regionName) {
      Array.from(footerSelect.options).forEach((opt) => {
        opt.selected =
          opt.textContent.trim() === regionName ||
          opt.value.toUpperCase() === selectedRegion;
      });
    }

    footerSelect.addEventListener("change", (e) => {
      const selectedOption = e.target.options[e.target.selectedIndex];
      const regionName = selectedOption.textContent.trim();

      selectedRegion = selectedOption.value.toUpperCase();
      updateAllRegions(selectedRegion, regionName);

      redirectWithSwitchingParam(selectedOption);
    });

    window.addEventListener("pageshow", (event) => {
      syncFooterSelect(selectedRegion);
    });
  }

  function alignDesktopDropdowns() {
    const navbarEl = document.querySelector("header .navbar");
    if (!navbarEl) return;
    const navbarRect = navbarEl.getBoundingClientRect();

    const regionBtnDesktop = document.querySelector(".nav-right .region-btn");
    if (regionBtnDesktop && countryDropdownDesktop) {
      const textSpan = regionBtnDesktop.querySelector("span.text") || regionBtnDesktop;
      const textRect = textSpan.getBoundingClientRect();
      const paddingLeft = parseFloat(getComputedStyle(countryDropdownDesktop).paddingLeft) || 0;
      countryDropdownDesktop.style.left = `${textRect.left - navbarRect.left - paddingLeft}px`;
      countryDropdownDesktop.style.right = "auto";
    }

    if (languageDropdownBtnDesktop && translationDropdownDesktop) {
      const textSpan = languageDropdownBtnDesktop.querySelector("span.text") || languageDropdownBtnDesktop;
      const textRect = textSpan.getBoundingClientRect();
      const paddingLeft = parseFloat(getComputedStyle(translationDropdownDesktop).paddingLeft) || 0;
      translationDropdownDesktop.style.left = `${textRect.left - navbarRect.left - paddingLeft}px`;
      translationDropdownDesktop.style.right = "auto";
    }
  }

  alignDesktopDropdowns();
  window.addEventListener("resize", alignDesktopDropdowns);
  window.addEventListener("scroll", alignDesktopDropdowns);
});
